import { useEventCallback } from '@mui/material/utils';

import { TimeTrackingStopwatch } from '@work4all/models/lib/Classes/TimeTrackingStopwatch.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useDataMutation } from '../../data-provider';

type StartStopwatchArgs = {
  projectCode: number;
  startTime: string;
  articleWorkItemCode: number;
  customerCode: number;
  projectStepCode: number;
  orderConfirmationCode: number;
  orderConfirmationPositionCode: number;
  ticketId: string;
  note: string;
};

type StartStopwatchFunctionProps = {
  data: StartStopwatchArgs;
};

export const useStartStopwatch = () => {
  const [mutate] = useDataMutation<
    TimeTrackingStopwatch,
    EMode.upsert,
    StartStopwatchArgs
  >({
    entity: Entities.timeTrackingStopwatch,
    mutationType: EMode.upsert,
    responseData: {
      id: null,
    },
  });

  return useEventCallback(async ({ data }: StartStopwatchFunctionProps) => {
    return mutate(
      {},
      {
        arguments: data,
      }
    );
  });
};
